export const developmentStatus = [
	"Development",
	"Live - Core",
	"Live - Seasonal",
	"Live - Retail",
	"Live - Exclusive",
	"Ats",
	"Development Dropped",
];